(function () {
 'use strict';
 if (window.__amourControlClearance) return;
 window.__amourControlClearance = true;
 var frame, activator;
 function update() {
  frame = null;
  if ((!activator || !activator.isConnected) && !bind()) return;
  activator.style.translate = '';
  if (innerWidth > 749 || activator.getAttribute('aria-expanded') === 'true') { activator.style.visibility = ''; return; }
  var r = activator.getBoundingClientRect();
  var controls = Array.prototype.map.call(document.querySelectorAll('[data-ovale-pdp] button, [data-ovale-pdp] select, [data-ovale-pdp] a, [data-ovale-pdp] summary, .amour-reviews button, .amour-reviews select'), function(el) {
   var c=el.getBoundingClientRect();
   return c.width && c.height && getComputedStyle(el).visibility !== 'hidden' ? c : null;
  }).filter(Boolean);
  var shift = 0, conflicts;
  for (var i=0;i<16;i++) {
   conflicts=controls.filter(function(c){return c.right>r.left && c.left<r.right && c.bottom>r.top+shift && c.top<r.bottom+shift;});
   if (!conflicts.length) break;
   shift=Math.min.apply(null,conflicts.map(function(c){return c.top-r.bottom-12;}));
   if (r.top+shift<160) break;
  }
  var clear=!controls.some(function(c){return c.right>r.left && c.left<r.right && c.bottom>r.top+shift && c.top<r.bottom+shift;});
  activator.style.translate = clear && r.top+shift>=160 ? '0 '+shift+'px' : '';
  activator.style.visibility = clear && r.top+shift>=160 ? '' : 'hidden';
 }
 function schedule() { if (!frame) frame = requestAnimationFrame(update); }
 function bind() {
  var chat = document.querySelector('shopify-chat');
  var root=chat && chat.shadowRoot;
  var runtime=root && root.querySelector('shopify-agent-runtime');
  var button=root && (root.querySelector('button[part="activator"]') || (runtime && runtime.shadowRoot && runtime.shadowRoot.querySelector('button[part="activator"]')));
  if (!button) return false;
  if (activator===button) return true;
  activator = button;
  new MutationObserver(schedule).observe(button, {attributes:true, attributeFilter:['aria-expanded']});

  schedule();return true;
 }
 window.addEventListener('scroll', schedule, {passive:true});
 window.addEventListener('resize', schedule, {passive:true});
 document.addEventListener('click', schedule, true);
 var tries=0,timer=setInterval(function () { bind();if(++tries>=120)clearInterval(timer); },500);
})();
